import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter } from 'react-router-dom'
import { OrgContext } from 'features/organizations/OrgContext'
import { getChallengeId } from '../../challengeUtils'
import { Overview } from '../Overview'
import { Details } from '../Details'
import { Settings } from '../Settings'
import { AdminLeaderboard } from '../AdminLeaderboard'
import { Participants } from '../Participants'
import { ChallengesSideNav } from '../ChallengesSideNav'
import { CircleSpinner } from 'common/spinners'
import { Loadable } from 'common/Loadable'
import { SideNavLayout } from 'common/layouts/SideNavLayout'
import { goalActions, goalSelectors } from 'data/resources/goals'
import { goalParticipantActions, goalParticipantSelectors } from 'data/resources/goalParticipants'
import { milestoneSelectors } from 'data/resources/milestones'

export const _AdminApp = ({ children, ...props }) => {
  const { goal } = props
  const currentMember = window.rwgps?.config?.currentMember
  if (!goal) {
    return <div style={{ marginTop: '50px' }}>
      <CircleSpinner centered size={40} />
    </div>
  }
  return (
    <SideNavLayout
      nav={<ChallengesSideNav goalId={goal.id} clubId={goal.clubId} />}
      greyBg>
      <OrgContext.Provider value={{ isCurrentClub: true, currentMember }}>
        {children(props)}
      </OrgContext.Provider>
    </SideNavLayout>
  )
}

const LoadableAdminApp = ({ loadGoal, ...props }) => {
  const [resourceId, setResourceId] = useState(1)
  const resourceLoaded = () => {
    return Promise.all([
      loadGoal(),
      props.loadParticipants()
    ])
  }

  return <Loadable
    component={_AdminApp}
    resourceLoaded={resourceLoaded}
    resourceId={resourceId}
    forceRefetch={() => setResourceId(resourceId + 1)} // used in Settings to refetch goal and participants if eg dates change
    {...props}
  />
}

const mapStateToProps = (state, ownProps) => {
  const challengeId = getChallengeId(ownProps)
  return {
    goal: goalSelectors.find(state, challengeId),
    metaForGoal: goalSelectors.metaForGoal(state, challengeId),
    milestones: milestoneSelectors.byGoalId(state, challengeId),
    ranks: goalParticipantSelectors.ranksForGoal(state, challengeId),
    participant: pId => goalParticipantSelectors.find(state, pId),
    participants: goalParticipantSelectors.byGoalId(state, challengeId)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const goalId = getChallengeId(ownProps)
  return {
    loadGoal: () => dispatch(goalActions.read(goalId, { extras: 'milestones,route' })),
    updateGoal: (goalId, params) => dispatch(goalActions.update(goalId, params)),
    loadParticipants: paginationParams => dispatch(goalParticipantActions.list({ goalId, ...paginationParams }, { goalId }))
  }
}

export const AdminApp = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableAdminApp))

export const routes = (
  <AdminApp>
    {p => <>
      <Route path='/challenges/:challengeId/overview' render={() => <Overview {...p} />} />
      <Route path='/challenges/:challengeId/details' render={() => <Details {...p} />} />
      <Route path='/challenges/:challengeId/settings' render={() => <Settings {...p} />} />
      <Route path='/challenges/:challengeId/leaderboard' render={() => <AdminLeaderboard {...p} />} />
      <Route path='/challenges/:challengeId/participants' render={() => <Participants {...p} />} />
    </>}
  </AdminApp>
)
